import { render, staticRenderFns } from "./DisqualificationConfirmDetail.vue?vue&type=template&id=39d54417&scoped=true"
import script from "./DisqualificationConfirmDetail.vue?vue&type=script&lang=js"
export * from "./DisqualificationConfirmDetail.vue?vue&type=script&lang=js"
import style0 from "./DisqualificationConfirmDetail.vue?vue&type=style&index=0&id=39d54417&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d54417",
  null
  
)

export default component.exports